document.addEventListener('DOMContentLoaded', function () {
  var resizeTimer;

  function initQualitySlider() {
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
      return;
    }

    var $ = window.jQuery;

    $('.custom-quality-slider').each(function () {
      var $section = $(this);
      var $slider = $section.find('.custom-quality-slider__track');
      var $progressBar = $section.find('.custom-quality-slider__progress span');
      var $prevArrow = $section.find('.custom-quality-prev');
      var $nextArrow = $section.find('.custom-quality-next');

      if (!$slider.length) return;

      var slidesMobile = parseInt($slider.data('slides-mobile')) || 1;
      var slidesTablet = parseInt($slider.data('slides-tablet')) || 1;
      var slidesDesktop = parseInt($slider.data('slides-desktop')) || 1;

      function getSlidesToShow() {
        if (window.innerWidth <= 749) return slidesMobile;
        if (window.innerWidth <= 989) return slidesTablet;
        return slidesDesktop;
      }

      function updateProgress(event, slick, currentSlide) {
        var currentIndex = currentSlide || 0;
        var slidesToShow = slick.options.slidesToShow;
        var total = slick.slideCount;
        var progress = ((currentIndex + slidesToShow) / total) * 100;

        if (progress > 100) progress = 100;

        $progressBar.css('width', progress + '%');
      }

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      $slider.off('init reInit afterChange', updateProgress);
      $slider.on('init reInit afterChange', updateProgress);

      $slider.slick({
        slidesToShow: getSlidesToShow(),
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        adaptiveHeight: false,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow
      });
    });
  }

  initQualitySlider();

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initQualitySlider, 250);
  });
});